import React from "react";

const BookSectionTitle = ({ title, subTitle, type = "default" }) => {
  return (
    <div className="section-title">
      <div
        className={`section-title-text font-amaticsc-bold ${
          type === "yellow" ? "yellow-back" : ""
        }`}
      >
        {title}
      </div>
      <p className="section-sub-text font-kleeone">{subTitle}</p>
    </div>
  );
};

export default BookSectionTitle;
